"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTollRates = void 0;
const toll_rates_json_1 = __importDefault(require("../data/toll_rates.json"));
function isKeyof(obj, possibleKey) {
    return possibleKey in obj;
}
function calculateTollRates(vehicleType, tollFacility, entrypoint, exitpoint) {
    const hash_parts = [vehicleType, tollFacility];
    if (entrypoint) {
        hash_parts.push(entrypoint);
    }
    if (exitpoint) {
        hash_parts.push(exitpoint);
    }
    const hash = hash_parts.join('-');
    if (!isKeyof(toll_rates_json_1.default, hash)) {
        return null;
    }
    return toll_rates_json_1.default[hash];
}
exports.calculateTollRates = calculateTollRates;
